var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32294 2.323C4.35392 0.292254 7.64646 0.292404 9.67726 2.32288L10.2429 1.75742L9.67738 2.323C11.7076 4.35406 11.7078 7.64632 9.67741 9.67729L9.67735 9.67735L9.67729 9.67741C7.64631 11.7078 4.3538 11.7076 2.32304 9.67741L2.32298 9.67735L2.32291 9.67729C0.292394 7.64618 0.292279 4.35367 2.32294 2.323ZM10.243 1.75729C12.5857 4.10073 12.586 7.8996 10.243 10.243C7.8996 12.586 4.10047 12.5857 1.75729 10.243C-0.585632 7.8996 -0.585893 4.10047 1.75729 1.75729C4.10073 -0.585893 7.89986 -0.585632 10.243 1.75729ZM5.24415 3.42723C5.23476 3.82141 5.53529 4.14072 5.98608 4.14072C6.45566 4.14072 6.75593 3.82141 6.75619 3.42723C6.74654 3.01427 6.4554 2.70435 5.99522 2.70435C5.53529 2.70435 5.23476 3.014 5.24415 3.42723ZM5.99991 9.39162C6.43218 9.39162 6.78254 9.04127 6.78254 8.609V5.47849C6.78254 5.04622 6.43218 4.69587 5.99991 4.69587C5.56764 4.69587 5.21729 5.04622 5.21729 5.47849V8.609C5.21729 9.04127 5.56764 9.39162 5.99991 9.39162Z",
    fill: "#8F979F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTooltip);
export default __webpack_public_path__ + "static/media/gray-tooltip.08e59be6f4d50a6e00a3381b8317278d.svg";
export { ForwardRef as ReactComponent };